export const state = () => ({
	summary: null,
    refreshTimestamp: '',
    error: null,
});

export const getters = {
	summary(state) {
		return state.summary;
	},
	refreshTimestamp(state) {
		return state.refreshTimestamp;
	}
};

export const mutations = {
	setSummary(state, summary) {
		state.summary = summary;
	},
	setRefreshTimestamp(state, refreshTimestamp) {
		state.refreshTimestamp = refreshTimestamp;
    },
    setError(state, error) {
        state.error = error;
    }
};

export const actions = {
	async getReportSummary({dispatch, rootGetters}) {
		try {
			const queryParams = getUserQueryParams(rootGetters);
			const summary = await this.$axios.$get('/api/reportSummary', {params: queryParams});

			// From here, maybe we can break and set different props.
			// const customers = summary.customers;
			// const customerNames = customers.map(c => c.name);

			dispatch('setSummary', summary);
			dispatch('setRefreshTimestamp', this.$moment().calendar());
		} catch (error) {
			dispatch('setError', error);
			dispatch('setRefreshTimestamp', this.$moment().calendar());
		}
	},
	setError({commit}, error) {
		commit('setError', error);
	},
	async clearError({commit}) {
		commit('setError', null);
	},
	setSummary({commit}, summary) {
		commit('setSummary', summary);
	},
	setRefreshTimestamp({commit}, refreshTimestamp) {
		commit('setRefreshTimestamp', refreshTimestamp);
	}
};


function getUserQueryParams(rootGetters) {
	const queryParams = {};
	const isConversaEmployee = rootGetters['user/isConversaEmployee'];
	if (isConversaEmployee) {
		queryParams['employee'] = isConversaEmployee;
	}

	const guid = rootGetters['user/guid'];
	if (guid) {
		queryParams['customer'] = guid;
	}

	return queryParams;
}

export const strict = false;
